export const ManageRelationsFormDataConfig: any = [
  {
    key: 'partnerCode',
    label: 'Participant Code',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: true,
    disabled: true,
    placeholder: 'Enter Name',
    rules: {
      required: {
        value: true,
        message: 'Participant Name is Required'
      },
      minLength: {
        value: 3,
        message: 'Participant Name must be atleast 5 characters'
      }
    }
  },
  {
    key: 'providerCustomerCode',
    label: 'Provider Customer Code',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: true,
    placeholder: 'Enter Provider Customer Code',
    rules: {
      required: {
        value: true,
        message: 'Provider Customer Code is Required'
      }
    }
  }
];
export const requestRelationConfig: any = [
  ...ManageRelationsFormDataConfig,
  {
    key: 'connectionNotes',
    label: 'Connection Note ',
    labelStyleType: 'textAreaLabel',
    defaultValue: '',
    type: 'textArea',
    size: 6,
    required: true,
    placeholder: 'Enter Connection Note '
  }
];

export const ParameterTypeConfig = [
  {
    label: 'Authentication Header',
    value: 'authHeaders'
  },
  {
    label: 'Form Parameter',
    value: 'formParams'
  },
  {
    label: 'Request Header',
    value: 'requestHeaders'
  },
  {
    label: 'Authentication',
    value: 'primary'
  },
  {
    label: 'Request Body',
    value: 'authBodyParameters'
  }
];

export const PrimaryParamterConfig = [
  {
    label: 'Identifier',
    value: 'identifier'
  },
  {
    label: 'Secret',
    value: 'secret'
  },
  {
    label: 'Auth Url',
    value: 'authUrl'
  }
];
